import React, { useEffect, useState, useMemo } from "react";
import withRouter from "components/Common/withRouter";
import TableContainer from "components/Common/TableContainer";
import {
  Card, CardBody, Col, Container, Row, Spinner, Button,
  Modal, ModalHeader, ModalBody
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import axios from "axios";
import moment from "moment";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const API_BASE = "https://maasradarapi.stechomeyazilim.info";

const ContactMessagesList = () => {
  document.title = "İletişim Mesajları | Maaş Radar Admin Paneli";

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState({});

  const [detailModal, setDetailModal] = useState(false);
  const [detailItem, setDetailItem] = useState(null);

  function getAuthHeaders() {
    const token = localStorage.getItem("token");
    return { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" };
  }

  const fetchItems = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE}/ContactMessages?$orderby=CreatedAt desc&$top=200`, { headers: getAuthHeaders() });
      setItems(res.data.value || []);
    } catch (error) {
      console.error("Veriler alınamadı", error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchItems(); }, []);

  const showToast = (success, message) => {
    toastr.options = { positionClass: "toast-top-right", timeOut: 5000, closeButton: true, progressBar: true };
    if (success) toastr.success(message, "Başarılı");
    else toastr.error(message, "Hata");
  };

  const handleDelete = (id) => {
    if (!window.confirm("Bu mesajı silmek istediğinize emin misiniz?")) return;
    setProcessing(p => ({ ...p, [id + "delete"]: true }));
    axios.delete(`${API_BASE}/ContactMessages(${id})`, { headers: getAuthHeaders() })
      .then(() => { showToast(true, "Mesaj silindi."); fetchItems(); })
      .catch((err) => { console.error(err); showToast(false, "Silme sırasında hata oluştu."); })
      .finally(() => setProcessing(p => ({ ...p, [id + "delete"]: false })));
  };

  const openDetail = (item) => { setDetailItem(item); setDetailModal(true); };

  const columns = useMemo(() => [
    { Header: "ID", accessor: "Id", width: "80px" },
    { Header: "Ad Soyad", accessor: "FullName" },
    { Header: "E-posta", accessor: "Email" },
    { Header: "Konu", accessor: "Subject" },
    { Header: "Tarih", accessor: "CreatedAt", Cell: ({ value }) => value ? moment(value).format("DD.MM.YYYY") : "-" },
    {
      Header: "İşlemler", accessor: "actions", disableSortBy: true,
      Cell: ({ row }) => (
        <div className="d-flex gap-2">
          <Button size="sm" color="info" onClick={() => openDetail(row.original)}>Detay</Button>
          <Button size="sm" color="danger" disabled={processing[row.original.Id + "delete"]} onClick={() => handleDelete(row.original.Id)}>
            {processing[row.original.Id + "delete"] ? <Spinner size="sm" /> : "Sil"}
          </Button>
        </div>
      )
    }
  ], [processing]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="İletişim Mesajları" breadcrumbItem="Liste" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {loading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer columns={columns} data={items} isGlobalFilter={true} isAddOptions={false} customPageSize={10} className="custom-header-css" />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal isOpen={detailModal} toggle={() => setDetailModal(false)} size="lg">
        <ModalHeader toggle={() => setDetailModal(false)}>Mesaj Detayı</ModalHeader>
        <ModalBody>
          {detailItem && (
            <div>
              <p><strong>ID:</strong> {detailItem.Id}</p>
              <p><strong>Ad Soyad:</strong> {detailItem.FullName}</p>
              <p><strong>E-posta:</strong> {detailItem.Email}</p>
              <p><strong>Telefon:</strong> {detailItem.Phone || "-"}</p>
              <p><strong>Konu:</strong> {detailItem.Subject || "-"}</p>
              <p><strong>Mesaj:</strong> {detailItem.Message}</p>
              <p><strong>Tarih:</strong> {detailItem.CreatedAt ? moment(detailItem.CreatedAt).format("DD.MM.YYYY HH:mm") : "-"}</p>
            </div>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(ContactMessagesList);
